import { HttpResponse } from 'buzz_lib_models';

import { httpService as createHttpService } from './httpService2';

export class LegacyAuthHttpService {
  private static httpService = createHttpService();

  public static get = <T>(
    url: string,
    query: { [key: string]: any } = {},
    functionKey: string,
    signal?: AbortSignal,
    headers?: { [key: string]: any }
  ): Promise<T> => {
    const headersWithFunctionKey = {
      'x-functions-key': functionKey,
      ...headers,
    };

    return LegacyAuthHttpService.getResponsePromise<T>(() =>
      LegacyAuthHttpService.httpService.get(url, query, signal, headersWithFunctionKey)
    );
  };

  public static post = <T>(
    url: string,
    body: { [key: string]: any } = {},
    functionKey: string,
    headers: { [key: string]: any } = {}
  ): Promise<T> => {
    const headersWithFunctionKey = {
      'x-functions-key': functionKey,
      ...headers,
    };
    return LegacyAuthHttpService.getResponsePromise<T>(() =>
      LegacyAuthHttpService.httpService.post(url, body, headersWithFunctionKey)
    );
  };

  public static put = <T>(
    url: string,
    body: { [key: string]: any } = {},
    functionKey: string,
    headers?: { [key: string]: any }
  ): Promise<T> => {
    const headersWithFunctionKey = {
      'x-functions-key': functionKey,
      ...headers,
    };

    return LegacyAuthHttpService.getResponsePromise<T>(() =>
      LegacyAuthHttpService.httpService.put(url, body, headersWithFunctionKey)
    );
  };

  public static delete = <T>(
    url: string,
    body: { [key: string]: any } = {},
    functionKey: string,
    headers?: { [key: string]: any }
  ): Promise<T> => {
    const headersWithFunctionKey = {
      'x-functions-key': functionKey,
      ...headers,
    };

    return LegacyAuthHttpService.getResponsePromise<T>(() =>
      LegacyAuthHttpService.httpService.delete(url, body, headersWithFunctionKey)
    );
  };

  private static getResponsePromise = <T>(action: () => Promise<HttpResponse | null>) => {
    return new Promise<T>((resolve, reject) => {
      action()
        .then(resp => {
          if (resp?.StatusCode.toString().startsWith('2')) {
            resolve(resp.Body as T);
          } else {
            reject(resp?.Body);
          }
        })
        .catch(e => reject(e));
    });
  };
}
